import React from 'react';
import './Description.css'

export default function Description(){
  return(
    <section className='app-description'>
      <h1>JobReel</h1>
      <h2>Cast a wide net for your dream job.</h2>
      <p>There are a lot of moving pieces in a job hunt.  
        Keep yourself organized and on task with JobReel's 
        all-encompassing interface.  Search new postings and 
        expand your network with our integrated job and 
        industry event search, and track your application 
        process from start to finish through the dashboard.  
      </p>
    </section>
  )
}